import { inject, Service } from '@angular/core';
import { HttpService } from '@data-services/http/http.service';
import { DoorDetailConfig } from '@models/companies';

@Service()
export class DoorDetailConfigDataService {
  private readonly http = inject(HttpService);

  async getDoorDetailConfigAsync(projectId: string, companyId: string): Promise<DoorDetailConfig> {
    return await this.http.getObjectAsync<DoorDetailConfig>(`projects/${projectId}/company/${companyId}/doorDetailConfig`);
  }

  async saveDoorDetailConfigAsync(config: DoorDetailConfig): Promise<void> {
    await this.http.postObjectAsync<DoorDetailConfig, unknown>('projects/company/saveDoorDetailConfig', config);
  }
}
